<template>
  <div class="detail">
    <div class="d bar back_left" @click="goBack">
      <p class="a_back">
        <van-icon name="arrow-left" color="#fff" size="28" />
      </p>
    </div>

    <div id="iframe-container">
      <iframe
        :src="iframeSrc"
        ref="iframe"
        scrolling="auto"
        frameborder="0"
        id="iframe"
      ></iframe>
    </div>

    <div class="detail-footer">
      <div class="detail-footer-update">
        <div v-if="fieldInfo.status == 0">您提交的项目正在审核中</div>
        <div v-if="fieldInfo.status == 1" class="fcR2 font3">
          您提交的信息已通过审核并计入统计结果
        </div>
        <div v-if="fieldInfo.status == 2" class="fcR font3">
          抱歉，您提交的信息未通过审核，请重新填报
        </div>

        <van-button
          round
          :class="`${
            fieldInfo.status == 1
              ? 'update_fcR2'
              : fieldInfo.status == 2
              ? 'update_fcR'
              : ''
          }`"
          type="info"
          native-type="submit"
          @click="onSubmit"
          >修改</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Dialog } from "vant";
import { infoFieldForm } from "@/service/form";
import { getRadioValue } from "@/common/js";

export default {
  name: "infoDetail",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      list: [],
      fieldInfo: {},
      showCalendar: false,
      iframeSrc: "",
    });
    onMounted(async () => {
      const { url } = route.query;
      state.iframeSrc = url;
      await getInfoFieldForm();
      await sendMessage();
    });

    const getInfoFieldForm = async () => {
      const { id } = route.query;
      if (id) {
        const { code, data } = await infoFieldForm({ fid: id });
        if (code === 10000 && data) {
          state.fieldInfo = data;

          tips(data.status);
        }
      }
    };
    const tips = (status) => {
      let msg = "";
      switch (status) {
        case 0:
          msg = "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~";
          break;
        case 1:
          msg = "您提交的信息已通过审核并计入统计结果";

          break;
        case 2:
          msg = "您提交的信息未通过审核，请修改后重新提交";
          break;
      }
      if (msg !== "") {
        Dialog.alert({
          message: msg,
        }).then(() => {});
      }
    };

    const sendMessage = () => {
      const { fieldInfo } = state;
      const iframeWin = document.getElementById("iframe").contentWindow;
      let ifData = {
        type: "info",
        data: {},
      };
      if (fieldInfo.list.length > 0) {
        for (const item of fieldInfo.list) {
          ifData.data[item.fieldCode] = item.value;
        }
      }
      setTimeout(() => {
        iframeWin.postMessage(JSON.stringify(ifData), "*");
      }, 1000);
    };

    const onSubmit = async (values) => {
      console.log("修改", values);
      const { id, url } = route.query;
      if (id) {
        router.push({ path: "/info/add", query: { id, url, type: 2 } });
      }
    };

    const goBack = () => {
      console.log("goBack");
      router.push({ path: "/info/list" });
    };
    return {
      ...toRefs(state),
      onSubmit,
      getRadioValue,
      goBack,
    };
  },
  components: {},
};
</script>

<style lang="less" scoped>
@import "../../../common/style/mixin";
.detail {
  height: 100%;
  &-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px; /* 底部高度 */
    line-height: 50px;
    color: @primary;
    font-size: 16px;
    background: #fff;
    max-width: 640px;
  }
  &-footer-update {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
  }
  .van-button--round {
    border-radius: 0;
    height: 50px; /* 底部高度 */
    line-height: 50px;
    width: 100px;
  }
}
#iframe-container {
  height: 100%;
  width: 100%;
}
#iframe-container iframe {
  height: 100%;
  width: 100%;
}
.back_left {
  position: absolute;
  margin-top: 5px;
}
.update_fcR2 {
  background: linear-gradient(to right, #ff6d19, #ff6d19, #ff6d19);
}
.update_fcR {
  background: linear-gradient(to right, #fd3535, #fd3535, #fd3535);
}
.font3 {
  font-size: 0.3rem;
}
</style>
